import styled from 'styled-components'

export const TabWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
  padding: 0.5rem 0;
`

export const SectionHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-size: 0.75rem;
  font-weight: 700;
  color: #6b7280;
  letter-spacing: 0.05em;
  text-transform: uppercase;
  margin-bottom: 0.5rem;
`

export const ChecklistContainer = styled.div`
  border: 1px solid #e5e7eb;
  border-radius: 0.5rem;
  overflow: hidden;
  background: #ffffff;
`

export const ChecklistRowItemWrapper = styled.div`
  border-bottom: 1px solid #f3f4f6;

  &:last-child {
    border-bottom: none;
  }
`

export const ChecklistRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0.5rem 0.875rem;
  transition: background-color 0.15s ease;

  &:hover {
    background-color: #f9fafb;
  }
`

export const DocDropdownContent = styled.div`
  background-color: #f9fafb;
  border-top: 1px dashed #e5e7eb;
  padding: 0.375rem 0.75rem 0.375rem 1.25rem;
  display: flex;
  flex-direction: column;
  gap: 0.375rem;
  align-items: flex-start;
`

export const DocDropdownRow = styled.div`
  display: flex;
  align-items: center;
  gap: 0.75rem;
  width: 100%;
`

export const DocFileItem = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.5rem;
  background: #ffffff;
  border: 1px solid #e5e7eb;
  border-radius: 0.375rem;
  padding: 0.25rem 0.5rem;
  max-width: 220px;
  width: 220px;
  height: 32px;
  flex-shrink: 0;
`

export const ExpirationInput = styled.input`
  font-size: 0.75rem;
  padding: 0.25rem 0.625rem;
  border: 1px solid #e5e7eb;
  border-radius: 0.375rem;
  color: #374151;
  outline: none;
  width: 180px !important;
  max-width: 180px !important;
  height: 32px !important;
  background-color: #ffffff !important;
  box-shadow: none !important;
  flex-shrink: 0;

  &:focus {
    border-color: #2563eb;
    background-color: #ffffff !important;
  }

  &::placeholder {
    color: #9ca3af;
    font-size: 0.6875rem;
  }
`

export const DocFileInfo = styled.div`
  display: flex;
  align-items: center;
  gap: 0.375rem;
  overflow: hidden;
`

export const DocFileName = styled.span`
  font-size: 0.6875rem;
  font-weight: 500;
  color: #374151;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`

export const DocFileSize = styled.span`
  font-size: 0.625rem;
  color: #9ca3af;
`

export const DocLabel = styled.span`
  font-size: 0.8125rem;
  font-weight: 500;
  color: #374151;
`

export const DocActions = styled.div`
  display: flex;
  align-items: center;
  gap: 0.625rem;
`

export const StatusTag = styled.span<{ $status: string }>`
  font-size: 0.65rem;
  font-weight: 700;
  padding: 0.15rem 0.5rem;
  border-radius: 0.25rem;
  text-transform: uppercase;
  letter-spacing: 0.03em;

  ${({ $status }) => {
    switch ($status) {
      case 'PENDENTE':
        return `
          background-color: #FEE2E2;
          color: #DC2626;
        `
      case 'ENTREGUE':
      case 'VALIDO':
        return `
          background-color: #DCFCE7;
          color: #16A34A;
        `
      case 'VENCIDO':
        return `
          background-color: #FEE2E2;
          color: #DC2626;
        `
      case 'N/A':
      default:
        return `
          background-color: #F3F4F6;
          color: #9CA3AF;
        `
    }
  }}
`

export const IconButton = styled.button`
  background: transparent;
  border: none;
  cursor: pointer;
  color: #6b7280;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0.25rem;
  border-radius: 0.25rem;
  transition: color 0.15s ease, background-color 0.15s ease;

  &:hover {
    color: #111827;
    background-color: #e5e7eb;
  }
`

export const WarningBanner = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  color: #d97706;
  font-size: 0.8125rem;
  font-weight: 600;
  margin-top: -0.5rem;
`

export const GeneralAttachmentCard = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0.75rem 1rem;
  border: 1px solid #e5e7eb;
  border-radius: 0.5rem;
  background-color: #ffffff;
  margin-bottom: 0.75rem;
`

export const GeneralAttachmentInfo = styled.div`
  display: flex;
  align-items: center;
  gap: 0.75rem;
`

export const IconBox = styled.div`
  width: 2.25rem;
  height: 2.25rem;
  border-radius: 0.375rem;
  background-color: #f3f4f6;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #4b5563;
`

export const FileDetails = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.125rem;
`

export const FileTitle = styled.span`
  font-size: 0.875rem;
  font-weight: 600;
  color: #111827;
`

export const FileMeta = styled.span`
  font-size: 0.75rem;
  color: #6b7280;
`
